import React from "react";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import BlockIcon from '@material-ui/icons/Block';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import {ReactComponent as AcceptedExpertIconSmall} from "../../../../images/state/expert_24.svg";

//1 в разработке
//2 на экспертизе
//3 одобрено экспертом
//4 отклонена
//5 на публикации
//6 опубликована

export const SmallStateIcon = ({stateid, classname}) => {
  switch(stateid) {
    case 1:
      return <EditOutlinedIcon/>;
    case 2:
      return <AccessTimeIcon/>;
    case 3:
      return <AcceptedExpertIconSmall class={classname}/>;
    case 4:
      return <BlockIcon/>;
    case 5:
      return <AccessTimeIcon/>;
    case 6:
      return <CheckCircleOutlineIcon/>;
    default:
      return <HelpOutlineIcon/>;
  }
};

export function StateText(stateid) {
  switch (stateid) {
    case 1:
      return "в разработке";
    case 2:
      return "на экспертизе";
    case 3:
      return "одобрено экспертом";
    case 4:
      return "отклонено";
    case 5:
      return "на публикации";
    case 6:
      return "опубликована";
    default:
      return "без статуса";
  }
}

export function StateTextColor(stateid) {
  switch(stateid) {
    case 1:
      return "#778899";
    case 2:
      return "#007FBD";
    case 3:
      return "#FF9500";
    case 4:
      return "#F15454";
    case 5:
      return "#007FBD";
    case 6:
      return "#85C446";
    default:
      return "#000000";
  }
};

export const ColoredStateIcon = ({stateid}) => {
  switch(stateid) {
    case 1:
      return <EditOutlinedIcon style={{ color: "#778899", marginBottom: "-6px"}}/>;
    case 2:
      return <AccessTimeIcon style={{ color: "#007FBD", marginBottom: "-6px"}}/>;
    case 3:
      return <AcceptedExpertIconSmall
        style={{ display: "inline-block",
          marginBottom: "-8px",
          marginRight: "8px",
          color: "#FF9500"
        }}/>;
    case 4:
      return <BlockIcon style={{ color: "#F15454", marginBottom: "-6px"}}/>;
    case 5:
      return <AccessTimeIcon style={{ color: "#007FBD", marginBottom: "-6px"}}/>;
    case 6:
      return <CheckCircleOutlineIcon style={{ color: "#85C446", marginBottom: "-6px"}}/>;
    default:
      return <HelpOutlineIcon style={{ color: "#000000", marginBottom: "-6px"}}/>;
  }
};

export default {
  StateText,
  StateTextColor
}
